import React, { useState, useEffect } from "react";
import axiosInstance from "../../../../../axios";
import { getPaymentBaseurl } from "../../../../../_helpers";

const Dependent = ({
  selectionHandler,
  category,
  subCategory,
  step,
  location,
}) => {
  const currentUrl = window.location.href;
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [childCategory, setChildCategory] = useState();
  const fetchCategories = () => {
    axiosInstance
      .get(`${getPaymentBaseurl(currentUrl, true)}/v1/category?tags=0&filter=0`)
      .then((res) => {
        setCategoryData(res?.data?.data);
      });
  };

  const checkInsertInArray = (newCountry) => {
    let findStatus = categoryData.find((x) => {
      return x === newCountry;
    });
    if (!findStatus) {
      setCategoryData([...categoryData, newCountry]);
    }
  };

  const categoryChange = (event) => {
    if (event.target.value) {
      setSelectedCategory(event.target.value);
      const category = categoryData.find(
        (categorized) => categorized.parent_category === event.target.value
      );
      setChildCategory(category?.child_categories);
      selectionHandler(event.target, step);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    setSelectedCategory(category);
    setSelectedSubCategory(subCategory);
    if (category && subCategory) {
      const dummycategory = categoryData.find(
        (categorized) => categorized.parent_category === selectedCategory
      );
      setChildCategory(dummycategory?.child_categories);
    }
  }, [categoryData?.length > 0]);

  return (
    <div className="category-container">
      <div className="category-item">
        <select
          aria-label="category"
          className="category"
          name="category"
          onChange={categoryChange}
          value={selectedCategory ? selectedCategory : ""}
        >
          <option value="" hidden>
            Select a Category
          </option>

          {categoryData &&
            categoryData?.map((allCategory, index) => {
              return (
                <option key={index} value={allCategory?.parent_category}>
                  {allCategory?.parent_category}
                </option>
              );
            })}
        </select>
      </div>
      {location !== "createBundle" && (
        <>
          {selectedCategory && childCategory?.length > 0 && (
            <div className="category-item">
              <select
                name="subCategory"
                className="category"
                onChange={({ target }) => selectionHandler(target, step)}
                defaultValue={subCategory ? selectedSubCategory : ""}
              >
                <option hidden>Select a Subcategory</option>
                {childCategory?.map((allCategory, index) => {
                  return (
                    <option key={index} value={allCategory.name}>
                      {allCategory.name}
                    </option>
                  );
                })}
              </select>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Dependent;
